import { i18n } from "../../translate/i18n";

// O backend não escreve mais nada para o modelo (1.13.0). Nome, tom e emojis
// viram LINHAS no início do prompt base, escritas aqui no idioma da tela e
// visíveis/editáveis pelo cliente. Em pt as frases são idênticas às que a
// migração gravou nos agentes antigos, para serem reconhecidas e trocadas.
const TONS = ["formal", "amigavel", "descontraido", "tecnico"];
const IDIOMAS = ["pt", "en", "es"];
const PADRAO_TOM = "amigavel";

export const linhasDePersonalidade = ({ agentName, tone, useEmojis }, t = i18n.t.bind(i18n)) => {
  const tom = TONS.includes(tone) ? tone : PADRAO_TOM;
  return [
    agentName && String(agentName).trim()
      ? t("aeros.talkai.personalityLine.name", { name: String(agentName).trim() })
      : "",
    t(`aeros.talkai.personalityLine.tone.${tom}`),
    t(useEmojis ? "aeros.talkai.personalityLine.emojisOn" : "aeros.talkai.personalityLine.emojisOff"),
  ].filter(Boolean);
};

const escapa = (texto) => texto.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Toda frase de personalidade conhecida, em qualquer idioma da tela; a do
// nome vira regex com o nome livre.
const reconhecedores = () =>
  IDIOMAS.flatMap((lng) => {
    const t = i18n.getFixedT(lng);
    const fixas = [
      ...TONS.map((tom) => t(`aeros.talkai.personalityLine.tone.${tom}`)),
      t("aeros.talkai.personalityLine.emojisOn"),
      t("aeros.talkai.personalityLine.emojisOff"),
    ].map((frase) => new RegExp(`^${escapa(frase)}$`));
    const marcador = "__NOME__";
    const nome = new RegExp(
      `^${escapa(t("aeros.talkai.personalityLine.name", { name: marcador })).replace(marcador, ".+")}$`
    );
    return [...fixas, nome];
  });

const ehLinhaDePersonalidade = (linha, regras) => regras.some((r) => r.test(linha.trim()));

// Troca o bloco de personalidade do topo do prompt pelas linhas atuais. Só
// remove as linhas de personalidade CONSECUTIVAS do início (e a linha em
// branco que as separa do resto); qualquer outra linha do cliente fica.
export const aplicaPersonalidade = (texto, campos) => {
  const regras = reconhecedores();
  const linhas = String(texto || "").split("\n");
  let i = 0;
  while (i < linhas.length && ehLinhaDePersonalidade(linhas[i], regras)) i += 1;
  if (i > 0 && i < linhas.length && linhas[i].trim() === "") i += 1;
  const resto = linhas.slice(i).join("\n");
  const topo = linhasDePersonalidade(campos).join("\n");
  return resto ? `${topo}\n\n${resto}` : topo;
};
